/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Button,
  Heading,
  HStack,
  Spacer,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Tooltip,
  useToast,
} from '@chakra-ui/react';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import CQContainer from '../../components/layout/CQContainer';
import AppColors from '../../constants/AppColors';
import AuditProvider, { AuditContext } from '../../providers/AuditProvider';
import { withMultiProviders } from '../../hoc/withProvider';
import { useNavigate } from 'react-router-dom';
import ROUTES from '../../constants/Routes';
import { FONT_FAMILY } from '../../constants/Theme';
import { SearchIcon } from '@chakra-ui/icons';
import { ToastLoading } from '../../components/Loader';
import { TextInput, useTabStorage, usePaginationSessionStorage } from '@laxmimanogna/code-quick-components';
import { CustomTab } from '../../components/CustomTab';
import ChartUploadProvider from '../../providers/ChartUploadProvider';
import NewAuditTable from './components/tables/NewAuditTable';
import Select from 'react-select';
import AuditSheetProvider, { AuditSheetContext } from '../../providers/AuditSheetProvider';
import { FILTER_OPTIONS, FILTER_OPTIONS_TO_CHART_STATUS_MAP } from '../../constants/constants';
import { DASHBOARD_PAGE_NAME, DASHBOARD_TABLE_NAME } from './constants';

const AssignedAuditTabs = [
  
  {
    title: 'All Charts',
    header: 'All Charts',
    component: NewAuditTable,
  },
];


const DropdownComponent = ({
  options,
  setSelected,
  selected,
  placeholder = "Select Options",
  isDisabled=false,
  disabledText = "Dropdown disabled",
  isLoading=false,
  isClearable=true,
  isSearchable=true
}) => {
  const handleChange = (option) => {
    setSelected(option);
  }

  return (
    <div
    style={{
      flex:1,
    }}>
      <Select 
      options={options}
      onChange={handleChange}
      isClearable={isClearable}
      placeholder={placeholder}
      isDisabled={isDisabled}
      value={selected}
      isLoading={isLoading}
      isSearchable={isSearchable}
      /> 
    </div> 
  )
}


const AuditUploadContainerV2 = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const tabStorage = useTabStorage();
  const auditContext = useContext(AuditContext);
  const { 
      allCharts, 
      isAllChartsLoading, 
      getAllCharts, 
      filterParams,
      updateChartsV2,
      updateFilterParams,
      chartStatusFilters,
      setChartStatusFilters,
      handleApplyFilter
  } = auditContext;

  const {
    getPaginationSession
  } = usePaginationSessionStorage();

  const auditSheetContext = useContext(AuditSheetContext)

  const [selectedTab, setSelectedTab] = useState(0);
  const [onSearchText, setSearchText] = useState(getPaginationSession(DASHBOARD_PAGE_NAME, DASHBOARD_TABLE_NAME)?.search || '');
  
  const onOpenNotes = (obj, batchId, tabType = undefined) => {
    if (obj && Object.keys(obj).length) {
      if (obj.all) {
        delete auditSheetContext.commentFilters.sheet_name
        auditSheetContext.setCommentFilters({
          ...auditSheetContext.commentFilters,
          page: 1,
          tabType: tabType
        })
      } else if (obj.current) {
        auditSheetContext.setCommentFilters({
          ...auditSheetContext.commentFilters,
          sheet_name: "Sheet1",
          page: 1,
          tabType: tabType
        })
      }
    } else {
      auditSheetContext.setCommentFilters({
        ...auditSheetContext.commentFilters,
        batchId,
        sheet_name: "Sheet1",
        reverse: true,
        page: 1,
        tabType: tabType
      })
    }
  }

  const dropdownOptions = useMemo(
    () => FILTER_OPTIONS.map(val => ({ value: val, label: val })),
    [FILTER_OPTIONS]
  );

  const [selectedFilter, setSelectedFilter] = useState(() => ({
    value: FILTER_OPTIONS[tabStorage.getTab() || 0],
    label: FILTER_OPTIONS[tabStorage.getTab() || 0]
  }));

  useEffect(() => {
    if (!selectedFilter.value) {
      return;
    }
    tabStorage.setTab(FILTER_OPTIONS.indexOf(selectedFilter.value))
  }, [selectedFilter]);

  const { loadSpecialtyAuditors } = auditContext;

  useEffect(() => {
    auditContext.getAllUsers();

    loadSpecialtyAuditors();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    showLoaderToast(auditContext.isUpdating);
  }, [auditContext.isUpdating]);

  useEffect(() => {
    showLoaderToast(auditContext.isAssigningChartToSelf);
  }, [auditContext.isAssigningChartToSelf]);

  function showLoaderToast(isLoading) {
    if (isLoading) {
      toast({
        render: ToastLoading,
        duration: null,
        id: 'loading-toast',
        position: 'top-right',
      });
    } else {
      toast.close('loading-toast');
    }
  }

  const onSearchAction = () => {
    auditContext.handleApplyFilter({
      ...auditContext.filterParams,
      searchText: onSearchText,
    });


  };

  const onFilterChange = e => {
    if (e) {
      setSearchText(e.target.value);
    } else {
      setSearchText('');
    }
  };

  return (
    <CQContainer>
      <HStack mb={5}>
        <Heading as="h5" fontSize="24px">
          {AssignedAuditTabs[0].header}
        </Heading>
        <Spacer />
        <Button
          mr={1}
          color={AppColors.secondary}
          // style={{ paddingInline: '20px', outlineColor: AppColors.secondary }}
          _hover={{bg:AppColors.secondary,color:AppColors.white}}
          width={'203px'}
          height={'50px'}
          border={'1px solid'}
          borderColor={AppColors.secondary}
          borderRadius="3xl"
          bgColor={'transparent'}
          fontSize={'16px'}
          onClick={() => {
            navigate(ROUTES.OFFLINE_UPLOAD_CHART);
          }}
        >
          Offline Chart Upload
        </Button>
      </HStack>
      <Box bg="white" p={4} w="100%" style={{ borderRadius: '12px' }} marginLeft={0}>
        <Tabs
          fontFamily={FONT_FAMILY.baiJamurjee}
          onChange={setSelectedTab}
          index={selectedTab}
        >
          <TabList borderBottom={'1px solid'}>
            <HStack w={'100%'} justifyContent={'space-between'}>
              {/* filtersss */}
              <Box width={"30%"}>
                <DropdownComponent
                options={dropdownOptions}
                selected={selectedFilter}
                setSelected={option => {
                  setSelectedFilter(option);
                  setChartStatusFilters(FILTER_OPTIONS_TO_CHART_STATUS_MAP[option.value]);
                  getAllCharts.loadPageByFilterParams(DASHBOARD_PAGE_NAME, DASHBOARD_TABLE_NAME, {chart_statuses: FILTER_OPTIONS_TO_CHART_STATUS_MAP[option.value]})
                }}
                placeholder=''
                isClearable={false}
                isSearchable={false}
                isDisabled={isAllChartsLoading}
                isLoading={isAllChartsLoading}
                />
              </Box>
 

              <Box>
                <TextInput
                height={'50px'}
                mb={'10px'}
                verticalAlign={'center'}
                  borderRadius={'md'}
                  value={onSearchText}
                  onChange={e => onFilterChange(e)}
                  onKeyDown={e => {
                    if (e.keyCode === 13) {
                      onSearchAction();
                    }
                  }}
                  // mb="2"
                  rightIconProps={{ zIndex: 0 }}
                  placeholder="Search"
                  rightIcon={<SearchIcon style={{marginTop:'15px'}} onClick={onSearchAction} />}
                  isDisabled={isAllChartsLoading}
                />
              </Box>
            </HStack>
          </TabList>

          <TabPanels>
            {AssignedAuditTabs.map((aa, index) => {
              return (
                <TabPanel p={0} key={`assigned-audit-panel-${index}`}>
                  <aa.component 
                  key={`my-charts-panel-${index}`} 
                  onOpenNotes={onOpenNotes}
                  PAGE_NAME={DASHBOARD_PAGE_NAME}
                  TABLE_NAME={DASHBOARD_TABLE_NAME}
                  />
                </TabPanel>
              );
            })}
          </TabPanels>
        </Tabs>
      </Box>
    </CQContainer>
  );
};

export default withMultiProviders(
  [AuditProvider, ChartUploadProvider, AuditSheetProvider],
  AuditUploadContainerV2
);
